import { AutoRollLogic } from "@orbital/games-frontend-library"

export const helperAutoConfigs = (
  configs: any,
  bet: string,
  setautoConfigs: any,
  autorollLogic: any,
  gameInfo: any,
  setisAutoOn: any,
  sendBet: any,
) => {
  setautoConfigs(configs)
  autorollLogic.current = new AutoRollLogic(
    bet,
    gameInfo.maxBet,
    true,
    "0",
    true,
    "0",
    "0.00",
    "0.00",
    configs.numberOfBets,
    gameInfo.precision,
  )

  setisAutoOn(true)
  sendBet(bet)
}
